<template>
    <div>
        <b-modal id="modal-Waitinglist" class="modal-form" title="Add Waitinglist" @hidden="CLEAR_FORM" centered hide-footer>
            <ValidationObserver ref="form">
            
                <validation-provider rules="required" v-slot="{ errors }">
                    <div class="form-group mt-3">
                        <label>Event Name</label>
                        <input v-model="form_waitinglist.title" type="text" class="form-control" name="name">
                        <div class="invalid-input">{{ errors[0] }}</div>
                    </div>
                </validation-provider>

                <validation-provider rules="required" v-slot="{ errors }">
                    <label>Choose Waitinglist Type</label>
                    <div class="row-style row-style-pck">
                        <div class="style" v-for="(data,index) in waitinglist_type" :key="index"  @click="form_waitinglist.type = data.value" :class="form_waitinglist.type === data.value ? 'active' : ''">
                            <div class="style-item style-img">
                                <div class="style-tx">
                                    <div class="w-100">
                                        {{data.label}}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <input type="hidden" v-model="form_waitinglist.type">
                    <div class="invalid-input">{{ errors[0] }}</div>
                </validation-provider>
                
                <validation-provider rules="required" v-slot="{ errors }" v-if="form_waitinglist.type === 'WD_MP' || form_waitinglist.type === 'MP'">
                    <div class="form-group mt-3">
                        <label>Category Person</label>
                        <textarea v-model="form_waitinglist.person_category" class="form-control"></textarea>
                        <small>Tambahkan koma (,) untuk membuat lebih dari satu kategori person</small>
                        <div class="invalid-input">{{ errors[0] }}</div>
                    </div>
                </validation-provider>
    
                <div class="button-modal text-right mt-4">
                    <button v-on:click="validationForm(form_waitinglist.id)" type="button" class="btn btn-new" v-bind:class="loading ? 'btn-progress' : ''">
                        Save Data
                    </button>
                </div>

            </ValidationObserver>
        </b-modal>

        <b-modal id="modal-approveWaitinglist" class="modal-form" title="Approve Waitinglist" @hidden="CLEAR_FORM" centered hide-footer>
            <ValidationObserver ref="formapprove">

                <div class="form-group mt-3">
                    <label>Waiting List Code</label>
                    <h5>{{form_waitinglist.code}}</h5>
                </div>

                <validation-provider rules="required" v-slot="{ errors }">
                    <div class="form-group">
                        <label>Event Name</label>
                        <input v-model="form_waitinglist.title" type="text" class="form-control" name="name">
                        <div class="invalid-input">{{ errors[0] }}</div>
                    </div>
                </validation-provider>

                <validation-provider rules="required" v-slot="{ errors }">
                    <div class="form-group">
                        <label>Event Date</label>
                        <datetime v-model="form_waitinglist.date" zone='local' value-zone='local' type="date" input-class="form-control"></datetime>
                        <div class="invalid-input">{{ errors[0] }}</div>
                    </div>
                </validation-provider>

                <validation-provider rules="required" v-slot="{ errors }">
                    <div class="row-style row-style-pck">
                        <div class="style" @click="form_waitinglist.package = 'STANDARD'" :class="form_waitinglist.package === 'STANDARD' ? 'active' : ''">
                            <div class="style-item style-img">
                                <div class="style-tx">
                                    <div class="w-100">
                                        STANDART
                                        <span>1 Slot</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="style"  @click="form_waitinglist.package = 'PREMIUM'" :class="form_waitinglist.package === 'PREMIUM' ? 'active' : ''">
                            <div class="style-item style-img">
                                <div class="style-tx">
                                    <div class="w-100">
                                        PREMIUM
                                        <span>2 Slot</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="style"></div>
                        <div class="style"></div>
                    </div>
                    <input type="hidden" v-model="form_waitinglist.package">
                    <div class="invalid-input">{{ errors[0] }}</div>
                </validation-provider>
               
            </ValidationObserver>
            
            <div class="button-modal text-right mt-4">
                <button v-on:click="_approveWaitinglist()" type="button" class="btn btn-new" v-bind:class="loading ? 'btn-progress' : ''">
                    Save Data
                </button>
            </div>
    </b-modal>
    </div>
</template>

<script>
    import { mapState, mapActions, mapMutations} from 'vuex'
    import {ValidationProvider, ValidationObserver} from "vee-validate";
    import { Datetime } from 'vue-datetime';

    export default{
        data(){
            return{
                loading:false,
                show_feature:false,
                waitinglist_type:[
                    {value:'WD',label:'WEDDING'},
                    {value:'WD_MP',label:'WEDDING & MAPANDES'},
                    {value:'MP',label:'MAPANDES'},
                    {value:'BD',label:'BIRTHDAY'},
                ]
            }
        },
        components: {
            ValidationProvider,
            ValidationObserver,
            Datetime,
        },
        computed: {
            ...mapState('WaitinglistControl', {
                form_waitinglist: state => state.form_waitinglist,
                errors: state => state.errors
            }),
        },
        methods: {
            ...mapMutations('WaitinglistControl', ['CLEAR_FORM']),
            ...mapActions('WaitinglistControl', ['createWaitinglist','updateWaitinglist','approveWaitinglist']),
            ...mapActions('UsersControl', ['getProfile']),
            
            validationForm: function(id) {
                this.$refs.form.validate().then(success => {
                    if (!success) {
                        setTimeout(() => {
                            const errors = Object.entries(this.$refs.form.errors)
                                .map(([key, value]) => ({ key, value }))
                                .filter(error => error["value"].length);
                            this.$refs.form.refs[errors[0]["key"]].$el.scrollIntoView({
                                behavior: "smooth",
                                block: "center"
                            });
                        }, 100);
                    }else{
                        this.loading = true
                        if(id){
                            this.updateWaitinglist(id).then(() => {
                                this.loading = false
                                this.$bvModal.hide('modal-Waitinglist')
                                this.$emit('getWaitinglist');
                                this.$toast.success('Successfully Updated Waitinglist Event')
                            }).catch((error) => {
                                console.log(error)
                                this.loading = false
                                this.$toast.warning('Sorry, Something Error')
                            })
                        }else{
                            this.createWaitinglist().then(() => {
                                this.loading = false
                                this.$bvModal.hide('modal-Waitinglist')
                                this.$emit('getWaitinglist');
                                this.$toast.success('Successfully Added Waitinglist Event')
                            }).catch((error) => {
                                console.log(error)
                                this.loading = false
                                this.$toast.warning('Sorry, Something Error')
                            })
                        }
                    }
                })
            },
            _approveWaitinglist: function() {
                this.$refs.formapprove.validate().then(success => {
                    if (!success) {
                        setTimeout(() => {
                            const errors = Object.entries(this.$refs.formapprove.errors)
                                .map(([key, value]) => ({ key, value }))
                                .filter(error => error["value"].length);
                            this.$refs.formapprove.refs[errors[0]["key"]].$el.scrollIntoView({
                                behavior: "smooth",
                                block: "center"
                            });
                        }, 100);
                    }else{
                        this.loading = true

                        this.approveWaitinglist().then(() => {
                            this.loading = false
                            this.$bvModal.hide('modal-approveWaitinglist')
                            this.$emit('getWaitinglist');
                            this.$toast.success('Successfully Approve Waitinglist Event')
                        }).catch((error) => {
                            console.log(error)
                            this.loading = false
                            if(error.response.data.errors == 'slot'){
                                this.$toast.warning('Your slots are not enough')
                            }else{
                                this.$toast.warning('Sorry, Something Error')
                            }
                        })
                    }
                })
               
            }

        }
    }
</script>
